var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeroItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 172,
    viewBox: "0 0 173 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 86,
    r: 85,
    stroke: "#39A6EE",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_863_2396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 173,
    height: 172
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 86,
    r: 86,
    fill: "#8C9FB1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_863_2396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.45 35H67.32C61.64 35 57 39.62 57 45.32V127.51C57 133.19 61.62 137.83 67.32 137.83H105.45C111.13 137.83 115.77 133.21 115.77 127.51V45.32C115.77 39.62 111.15 35 105.45 35ZM112.19 127.28C112.19 131.06 109.12 134.13 105.34 134.13H67.44C63.66 134.13 60.59 131.06 60.59 127.28V45.52C60.59 41.74 63.66 38.67 67.44 38.67H105.34C109.12 38.67 112.19 41.74 112.19 45.52V127.28Z",
    fill: "#39A6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.896 87.4492V94.1699C100.896 97.7826 100.573 100.83 99.9268 103.312C99.2809 105.795 98.3525 107.793 97.1416 109.307C95.9307 110.82 94.4674 111.92 92.752 112.606C91.0566 113.272 89.1393 113.605 87 113.605C85.3047 113.605 83.7406 113.394 82.3076 112.97C80.8747 112.546 79.583 111.87 78.4326 110.941C77.3024 109.993 76.3337 108.762 75.5264 107.248C74.7191 105.734 74.1035 103.898 73.6797 101.738C73.2559 99.5788 73.0439 97.056 73.0439 94.1699V87.4492C73.0439 83.8366 73.3669 80.8092 74.0127 78.3672C74.6787 75.9251 75.6172 73.9674 76.8281 72.4941C78.0391 71.0007 79.4922 69.931 81.1875 69.2852C82.903 68.6393 84.8203 68.3164 86.9395 68.3164C88.6549 68.3164 90.2292 68.5283 91.6621 68.9521C93.1152 69.3558 94.4069 70.0117 95.5371 70.9199C96.6673 71.8079 97.626 72.9987 98.4131 74.4922C99.2204 75.9655 99.8359 77.7718 100.26 79.9111C100.684 82.0505 100.896 84.5632 100.896 87.4492ZM95.2646 95.0781V86.5107C95.2646 84.5329 95.1436 82.7972 94.9014 81.3037C94.6794 79.79 94.3464 78.4984 93.9023 77.4287C93.4583 76.359 92.8932 75.4912 92.207 74.8252C91.541 74.1592 90.764 73.6748 89.876 73.3721C89.0081 73.0492 88.0293 72.8877 86.9395 72.8877C85.6074 72.8877 84.4268 73.14 83.3975 73.6445C82.3682 74.1289 81.5003 74.9059 80.7939 75.9756C80.1077 77.0452 79.583 78.4479 79.2197 80.1836C78.8564 81.9193 78.6748 84.0283 78.6748 86.5107V95.0781C78.6748 97.056 78.7858 98.8018 79.0078 100.315C79.25 101.829 79.6032 103.141 80.0674 104.251C80.5316 105.341 81.0967 106.239 81.7627 106.945C82.4287 107.652 83.1956 108.176 84.0635 108.52C84.9515 108.842 85.9303 109.004 87 109.004C88.3724 109.004 89.5732 108.742 90.6025 108.217C91.6318 107.692 92.4896 106.875 93.1758 105.765C93.8822 104.634 94.4069 103.191 94.75 101.436C95.0931 99.6595 95.2646 97.5404 95.2646 95.0781Z",
    fill: "#39A6EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.27 45.7196C95.27 46.7496 94.44 47.5796 93.41 47.5796H79.45C78.42 47.5796 77.53 46.7796 77.5 45.7696C77.47 44.7096 78.33 43.8496 79.36 43.8496H93.41C94.44 43.8496 95.27 44.6796 95.27 45.7096V45.7196Z",
    fill: "#39A6EE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroItems);
export default __webpack_public_path__ + "static/media/zero_items.5dfed5e2a683d067989c6cf1f4e6c0f4.svg";
export { ForwardRef as ReactComponent };